import React from 'react';
import { MultiframeMode, getMultiframeModeName } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';

export interface ConfigMultiframeModeProps {
    multiframeModeList: MultiframeMode[];
    value: MultiframeMode;
    onChange: (value: MultiframeMode) => void;
}

const MultiframeModeSection: React.FC<ConfigMultiframeModeProps> = ({
    multiframeModeList,
    value: selectedMultiframeMode,
    onChange,
}) => {
    const multiframeModeRadioButtonList: RadioButtonEntry<MultiframeMode>[] = multiframeModeList.map(
        (field) => {
            return { value: field, label: getMultiframeModeName(field) };
        },
    );

    return (
        <ConfigSection title="Multiframe mode">
            <RadioButtonList
                list={multiframeModeRadioButtonList}
                selectedValue={selectedMultiframeMode}
                onChange={onChange}
            />
        </ConfigSection>
    );
};

export default MultiframeModeSection;
